<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('feng.order') }}
        <span v-if="area">[{{ area }}]</span>
      </div>
      <div class="top_right">
        <!-- 	<span  @click="$router.push('/moneybag')">
					<van-icon name="bill-o" size="25"/>
				</span> -->
        <!-- <span  @click="locationsel = true" style="margin-left: 8px;">
					<van-icon name="location-o" size="25"/>
				</span> -->
      </div>
    </div>
    <van-share-sheet
      v-if="arealist"
      v-model="locationsel"
      :title="$t('pro.select')"
      :options="arealist"
      :cancel-text="$t('utils.cancel')"
      @select="onSelect"
    />
    <div class="head-tabs">
      <span
        class="tab-item "
        :class="cur==0?'active':''"
        @click="cur=0;page=1;start();"
      >{{ $t('pro.all') }}</span>
      <span
        class="tab-item "
        :class="cur==1?'active':''"
        @click="cur=1;page=1;start();"
      >{{ $t('pro2.succ') }}</span>
      <span
        class="tab-item "
        :class="cur==2?'active':''"
        @click="cur=2;page=1;start();"
      >{{ $t('pro2.fail') }}</span>
      <span
        class="tab-item "
        :class="cur==3?'active':''"
        @click="cur=3;page=1;start();"
      >{{ $t('pro.processing') }}</span>
    </div>
    <div class="tab-content">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <div
        v-if="!empty"
        class="box"
      >
        <div class="list_wrap">
          <div
            v-for="(item, index) in list"
            class="list"
            @click="$router.push('/orderdetail/'+item.id)"
          >
            <div class="name-box">
              <div class="name">
                <span>{{ item.item?item.item.area:'' }}</span>
              </div>
              <div class="data">
                <span>{{ item.ino }}</span>
              </div>
            </div>
            <div class="viewInfo">
              <div class="match1 notranslate">
                <span v-if="item.da==1">{{ item.item?item.item.sda:'' }}</span>
                <span v-if="item.xiao==1">{{ item.item?item.item.sxiao:'' }}</span>
                <span v-if="item.dan==1">{{ item.item?item.item.sdan:'' }}</span>
                <span v-if="item.shuang==1">{{ item.item?item.item.sshuang:'' }}</span>
              </div>
              <div class="money">
                <span />
              </div>
            </div>
            <div class="viewInfo">
              <div class="match">
                <span>{{ parseInt(item.num) }} {{ utils_moneyMark() }}</span>
              </div>
              <div
                v-if="item.stat==0"
                class="padding"
              >
                <span>{{ $t('pro.processing') }}</span>
              </div>
              <div
                v-if="item.stat==1 && item.zhong>0"
                class="success"
              >
                <span>{{ $t('pro2.succ') }}</span>
              </div>
              <div
                v-if="item.stat==1 && item.zhong==0"
                class="error"
              >
                <span>{{ $t('pro2.fail') }}</span>
              </div>
            </div>
          </div>
        </div>
				
        <!-- <van-list
				  v-model="loading"
				  :finished="finished"
				  loading-text	="Loading..."
				  :finished-text="$t('feng.nomore')"
				  @load="start"
				>
					<div v-for="(item, index) in list" @click="$router.push('/orderdetail/'+item.id)">
						<van-card
						  :num="1*item.da+1*item.xiao+1*item.dan+1*item.shuang"
						  :price="parseInt(item.num)"
						  :desc="item.time"
						  currency='IDR '
						  :tag="item.stat=='0'?$t('pro.processing'):''"
						  :title="(item.item?item.item.area:'')+' 【'+item.ino+'】'"
						  :thumb="item.item?item.item.img:'../images/31/31.png'"
						>
						</van-card>
					</div>
				</van-list> -->
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,List,Card,ShareSheet 
	} from "vant";
    var _that;
	import Fetch from "../../utils/fetch";
	Vue.use(Empty).use(List).use(Card).use(ShareSheet);
	export default {
		name: "Order",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null,
				loading:false,
				page:1,
				list:null,
				cur:0,
				area:null,
				arealist:null,
				locationsel: false,
				type:0,
				finished:false,
				empty: false,
			};
		},
		created() {
			this.$parent.footer("order",true);
		},
		mounted() {
			Fetch('/index/item_search', {
				name: "",
				cate: 0
			}).then(r => {
				var list = r.data.list;
				var result = [];
				
				for (var i = 0; i < list.length; i ++) {
					var arr = [];
					if(list[i]){
						var it = {
							id:list[i].id,
							name:list[i].jt,
							icon:list[i].img
						};
						arr.push(it);
					}
					i++;
					
					if(list[i]){
						var it = {
							id:list[i].id,
							name:list[i].jt,
							icon:list[i].img
						};
						arr.push(it);
					}
					i++;
					if(list[i]){
						var it = {
							id:list[i].id,
							name:list[i].jt,
							icon:list[i].img
						};
						arr.push(it);
					}
					i++;
					if(list[i]){
						var it = {
							id:list[i].id,
							name:list[i].jt,
							icon:list[i].img
						};
						arr.push(it);
					}
					i++;
					if(list[i]){
						var it = {
							id:list[i].id,
							name:list[i].jt,
							icon:list[i].img
						};
						arr.push(it);
					}
					result.push(arr);
				}
				this.arealist = result;
			});
			
			this.start();
			_that = this;
		},
		methods: {
			onSelect(option) {
				this.area = option.name;
				this.type = option.id;
				this.start();
				this.locationsel = false;
			},
			start() {
				this.loading = true;
				Fetch("/user/item_orders",{
					cur: this.cur,
					type:this.type,
                    page:this.page
                }).then((r) => {
					this.data = r.data;
					r.data.list.length == 0 ?
						(this.empty = true) :
						(this.empty = false);
					
					if(r.data.list.length>0){
						// for(var i=0;i<r.data.list.length;i++){
							
						// }
						this.list = r.data.list;
						this.finished=true;
						this.loading = false;
					}
				});
			},
			
			// receiveRewards(item){
			// 	var index = -1;
			// 	 for(var i=0;i<this.data.list.length;i++){
			// 		if(this.data.list[i].id==item.id){
			// 				index =i;
			// 			}
			// 	}
			// 	// if(this.data.list[index].isdisabled == true){
			// 	// 	if(this.data.list[index].day <= this.data.list[index].day_index){
			// 	// 		alert('Cannot be claimed repeatedly');			 
			// 	// 	}					
			// 	// 	return;
			// 	// }
			// 	Fetch("/index/receiveRewards", {
			// 	  id: item.id
			// 	}).then(r => {
			// 	   console.log(r );
			// 		Dialog.alert({
			// 			message: window.vm.$i18n.t('item.getincome')+ r.data.price,
			// 			confirmButtonText: window.vm.$i18n.t('utils.confirm')
			// 		});
					
			// 		this.data.list[index].isling = '0'
			// 		var sysdate = new Date(r.data.sys_date);
			// 		var millSeconds = Math.abs(sysdate) + (1000*60*60*24-1);
			// 		var date1 = new Date(millSeconds);
			// 		var M = (date1.getMonth()+1 < 10 ? '0'+(date1.getMonth()+1) : date1.getMonth()+1) + '-';		
			// 		var sysTime = sysdate.getFullYear() + '-' + M + sysdate.getDate() + ' '+ sysdate.getHours() + ':' + sysdate.getMinutes() + ':' + sysdate.getSeconds();			 
			// 		var countTime = date1.getFullYear() + '-' + M + date1.getDate() + ' '+ date1.getHours() + ':' + date1.getMinutes() + ':' + date1.getSeconds();
			// 		this.data.list[index].sys_time = sysTime;
			// 		this.data.list[index].count_time = countTime;
			// 	}).catch(err=>{
			// 		Dialog.alert({
			// 			message: window.vm.$i18n.t('item.getincomefail'),
			// 			confirmButtonText: window.vm.$i18n.t('utils.confirm')
			// 		});
			// 	})
			// }
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		
	}
.dlg-orderlist{
width: 100%;
height: 100%;
background: #f5f5f5;

.main {
overflow: hidden
}

.vux-x-icon {
fill: #fff
}

.ctn {
position: relative;
height: 100%
}

.weui-cells {
margin-top: 0
}

.vux-button-group {
padding: 10px
}

.vux-button-group>a {
height: 36px;
line-height: 36px
}

.vux-button-group>a.vux-button-group-current {
color: #fff
}

.tab-content {
position: absolute;
overflow-y: auto;
top: 50px;
bottom: 0;
left: 0;
right: 0;
padding-bottom: 84px;
-webkit-overflow-scrolling: touch
}

.tab-content .weui-cell {
padding: 10px
}

.tab-content .vux-divider {
color: #999;
font-size: 14px;
padding: 10px
}

.tab-content .weui-form-preview__bd {
font-size: 14px
}

.weui-cell_access .weui-cell__ft {
width: 100%
}

.btTime {
text-align: left
}

.btTime .s_1 {
display: inline-block;
color: #999;
font-size: 13px;
margin-right: 1rem
}

.btTime .s_2 {
font-size: 16px;
color: #333
}

.btDate,.btTime .s_6 {
font-size: 12px;
color: #999
}

.btDate {
text-align: left
}

.btDate .s_3 {
display: inline-block;
margin-right: 1rem
}

.btDate .s_4 {
display: inline-block;
font-size: 13px;
color: #666;
padding-right: 5%;
max-width: 49%
}

.btDate .s_5 {
font-size: 12px
}

.isWin {
font-size: 14px;
color: #333
}

.lose {
color: green!important
}

.winFlag {
color: #ca2316!important
}

.vux-1px-r {
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis
}

@media screen and (max-device-width: 374px) {
	.btTime .s_2 {
		font-size:14px
	}

	.btDate .s_4,.btDate .s_5 {
		font-size: 12px
	}

	.isWin {
		font-size: 14px;
		margin-top: -10px
	}
}

	.h-ctb .ctb-bd dl, .h-ctb .ctb-hd {
		height: auto;
		padding: 10px 0;
		line-height: 18px;
		word-break: break-all
	}

	.h-ctb .ctb-hd dt {
		line-height: 18px
	}

	.h-ctb .ctb-bd {
		position: absolute;
		top: 40px;
		left: 0;
		right: 0;
		bottom: 30px;
		overflow-y: auto
	}
}
/deep/ .van-card__thumb{
	width: 68px;
	height: 68px;
}
/deep/ .van-card__content{
	min-height: 68px;
}
	.box{
		padding-bottom: 10vh;
	}
	
	.list_wrap{
		padding: 0;
		border-radius: 0 0 10px 10px;
		margin: 10px 13px 0;
		.list{
		    width: 100%;
		    background: #fff;
		    box-shadow: 0 2px 7px 2px rgba(0,0,0,.08);
		    border-radius: 11px;
		    padding: 0 10px 10px;
		    margin-bottom: 10px;
			.viewInfo{
			    display: flex;
			    align-items: center;
			    justify-content: space-between;
			    margin-top: 10px;
				.match1{
				    font-size: 15px;
				    font-family: PingFangSC-Regular,PingFang SC;
				    font-weight: 400;
				    color: #666;
				}
				.match{
				    font-size: 15px;
				    font-family: PingFangSC-Regular,PingFang SC;
				    font-weight: 400;
				    color: #333;
				}
				.padding{
				    font-size: 15px;
				    font-family: PingFangSC-Semibold,PingFang SC;
				    font-weight: 600;
				    color: #333;
				}
				.error{
				    font-size: 15px;
				    font-family: PingFangSC-Semibold,PingFang SC;
				    font-weight: 600;
				    color: #fe5443;
				}
				.success {
				    font-size: 15px;
				    font-family: PingFangSC-Semibold,PingFang SC;
				    font-weight: 600;
				    color: #40e32a;
				}
			}
			.name-box{
			    display: flex;
			    align-items: center;
			    justify-content: space-between;
			    height: 34px;
			    border-bottom: 1px solid #d8d8d8;
			    padding: 0;
				.name{
				    font-size: 12px;
				    font-family: PingFangSC-Medium,PingFang SC;
				    font-weight: 500;
				    color: #333;
				}
				.data{
				    font-size: 12px;
				    font-family: PingFangSC-Regular,PingFang SC;
				    font-weight: 400;
				    color: #666;
				}
			}
		}
	}
</style>
